//External
import React, { useState, useEffect } from "react";
//Internal
import { getFadeFlag } from "utils";
import { Link } from "./../../routes";
import FooterCopyright from "../footer-copyright";
import IconInstagram from "../icons/icons-instagram";
import IconFacebook from "../icons/icons-facebook";
import IconYoutube from "../icons/icons-youtube";
import IconLinkedin from "../icons/icons-linkedin";

/*******************
  @Purpose : used for footer sb
  @Parameter : {}
  @Author : INIC
  *******************/
function FooterSub({ currentPage, addressInfo, hideSocialIcons }) {
  const [isIosChrome, setIsIosChrome] = useState();

  /*******************
@purpose : Check device is iphone and set
@Parameter : {}
@Author : INIC
******************/
  useEffect(() => {
    setIsIosChrome(getFadeFlag());
  }, [isIosChrome]);
  /*******************
  @purpose : Rander HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <footer
        className={`${
          currentPage == "contact-us" ? "site-footer pb-0" : "site-footer"
        } ${isIosChrome ? "chrome-footer" : ""} `}
      >
        <div className="footer-bottom">
          <div className="custom-container">
            <div className="footer-bottom-row">

              {/* Copyright — bottom on mobile, left on desktop */}
              <div className="order-3 order-md-1 mt-2 mt-md-0">
                <FooterCopyright />
              </div>

              {/* Stripe — middle on both */}
              <div className="order-2 order-md-2 my-md-0 d-flex align-items-center" style={{ marginTop:'20px', marginBottom:'20px' }}>
                <img
                  src="/assets/images/stripe-badge.png"
                  alt="Powered by Stripe"
                  style={{ height: '26px', width: 'auto' }}
                />
              </div>

              {/* Social links — top on mobile, right on desktop */}
              {!hideSocialIcons && <ul className="list-unstyled d-flex align-items-center mb-0 social-links order-1 order-md-3">
                <li>
                  <Link
                    href={
                      addressInfo && addressInfo["company_instagram_url"]
                        ? addressInfo["company_instagram_url"]
                        : "#"
                    }
                    target="_blank"
                  >
                    <a title="Instagram" rel="noopener" target="_blank">
                      <IconInstagram />
                    </a>
                  </Link>
                </li>
                <li>
                  <Link
                    href={
                      addressInfo && addressInfo["company_facebook_url"]
                        ? addressInfo["company_facebook_url"]
                        : "#"
                    }
                    target="_blank"
                  >
                    <a title="Facebook" rel="noopener" target="_blank">
                      <IconFacebook />
                    </a>
                  </Link>
                </li>
                <li>
                  <Link
                    href={
                      addressInfo && addressInfo["company_youtube_url"]
                        ? addressInfo["company_youtube_url"]
                        : "#"
                    }
                    target="_blank"
                  >
                    <a title="YouTube" rel="noopener" target="_blank">
                      <IconYoutube />
                    </a>
                  </Link>
                </li>
                <li>
                  <Link
                    href={
                      addressInfo && addressInfo["company_linkedin_url"]
                        ? addressInfo["company_linkedin_url"]
                        : "#"
                    }
                    target="_blank"
                  >
                    <a title="LinkedIn" rel="noopener" target="_blank">
                      <IconLinkedin />
                    </a>
                  </Link>
                </li>
              </ul>}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default FooterSub;
